import { isEqual } from 'lodash';
import { loading, success, set, handleErrorException } from 'State/actions';

import * as types from './types';
import * as AppliedMenuSelectors from './selectors';

import { MESSAGES } from 'Pages/managemenu/helpers/Constants';

export const getAppliedMenus = (startDate, endDate) => {
  return async (dispatch, getState, MPWWebApi) => {
    const data = {
      StartDT: startDate,
      EndDT: endDate,
    };

    try {
      dispatch(loading(types.GET_APPLIED_MENUS, true));
      const response = await MPWWebApi.postGenericInsertUpdate(
        'DailyMenu/GetAppliedMenus',
        data
      );

      dispatch(success(types.SET_APPLIED_MENUS, response.data.Data));
    } catch (ex) {
      dispatch(
        handleErrorException(
          ex,
          types.GET_APPLIED_MENUS_ERROR,
          MESSAGES.GET_APPLIED_MENUS_ERROR
        )
      );
    } finally {
      dispatch(loading(types.GET_APPLIED_MENUS, false));
    }
  };
};

export const deleteAppliedMenu = data => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const state = getState();
      dispatch(loading(types.DELETE_APPLIED_MENUS_FETCHING, true));
      await MPWWebApi.postGenericInsertUpdate(
        'DailyMenu/DeleteAppliedMenu',
        data
      );

      const appliedMenus = AppliedMenuSelectors.getAppliedMenus(state);
      const newAppliedMenus = appliedMenus.filter(menu => !isEqual(menu, data));
      dispatch(success(types.SET_APPLIED_MENUS, newAppliedMenus));
      dispatch(setDeleteSuccessful(true));
    } catch (ex) {
      dispatch(
        handleErrorException(
          ex,
          types.DELETE_APPLIED_MENUS_ERROR,
          MESSAGES.DELETE_APPLIED_CYCLE_MENU_ERROR
        )
      );
    } finally {
      dispatch(loading(types.DELETE_APPLIED_MENUS_FETCHING, false));
    }
  };
};

export const setDeleteSuccessful = success =>
  set(types.SET_APPLIED_MENUS_DELETE_SUCCESSFUL, success);

export const clearError = () => ({
  type: types.CLEAR_APPLIED_MENUS_ERROR,
});



// WEBPACK FOOTER //
// ./src/pages/managemenu/state/listappliedmenus/actions.js